import { IAgentFlags } from "store/entities/agents";

export enum Product {
  ChatBot = "ChatBot",
  KnowledgeBase = "KnowledgeBase",
  LiveChat = "LiveChat",
  DeveloperProgram = "DeveloperProgram",
  PartnerProgram = "PartnerProgram",
  TextAccounts = "TextAccounts",
  TextApp = "TextApp",
}

export const PRODUCTS_KEYS = {
  [Product.DeveloperProgram]: "developerConsoleVisitedDate",
} satisfies Partial<Record<Product, keyof IAgentFlags>>;

export const PRODUCTS_NEW_FEATURE_CAMPAIGNS: { [key in Product]?: [string, string, string][] } = {
  [Product.DeveloperProgram]: [["2023-01-01T14:00:00.000Z", "2023-02-18T02:00:00.000Z", ""]],
  [Product.PartnerProgram]: [["2023-05-17T14:00:00.000Z", "2023-06-06T02:00:00.000Z", ""]],
};
